import React from 'react';
import { UUID } from '../model/uuid';
import { TextAnnotationScheme } from './scheme';
import { Token as TokenModel } from '../model/structure';
import { Token } from '../structure/token/token';
import { InputSpace } from '../structure/token/space';

interface TextAnnotationProps {
    annotationScheme: TextAnnotationScheme;
    tokenList: TokenModel[];
    activeTypeIds: UUID[];
}

interface TextAnnotationState {
    content: string[][];
}

export class TextAnnotation extends React.Component<TextAnnotationProps, TextAnnotationState> {
    constructor(props: TextAnnotationProps) {
        super(props);
        
        const maxTokenIndex = this.props.tokenList.map(
            t => t.tokenIndex
        ).reduce(
            (a, b) => Math.max(a, b)
        )

        // must fill with unique [], so map is necessary
        this.state = {
            "content": Array(maxTokenIndex + 1).fill(null).map(() => []),
        }
    }

    handlePlusClick(tokenIndex: number, position: number) {
        const content = this.state["content"].slice();
        content[tokenIndex].splice(position, 0, "");


        this.setState({
            "content": content,
        });
    }

    handleMinusClick(tokenIndex: number, position: number) {
        const content = this.state["content"].slice();
        content[tokenIndex].splice(position, 1);

        this.setState({
            "content": content,
        });
    }

    renderInput(tokenIndex: number) {
        if (!this.state.content[tokenIndex].length) {
            return (
                <span 
                 key={ 'textinput-' + tokenIndex } 
                 onClick={ () => this.handlePlusClick(tokenIndex, 0) }
                >
                    { " " }
                </span>
            );
        } else {
            return this.state.content[tokenIndex].map(
                (content, i) => <InputSpace
                                    key={ 'textinput-' + tokenIndex + '-' + i }
                                    content={ content }
                                    onPlusClick={ () => this.handlePlusClick(tokenIndex, i) }
                                    onMinusClick={ () => this.handleMinusClick(tokenIndex, i) }
                                />
            );
        }
    }

    render() {
        return (
            <> 
                {this.props.tokenList.map(
                    ps => <React.Fragment key={ps.tokenIndex}>
                            {/* <Token key={'token-' + ps.tokenIndex} {...ps} metaKeyClicked={false} shiftKeyClicked={false} currentMentionModel='entity'/> */}
                            <React.Fragment key={ 'textinput-' + ps.tokenIndex }>
                                { this.renderInput(ps.tokenIndex) }
                            </React.Fragment>
                        </React.Fragment>
                )} 
            </>
        );
    }
}

export default TextAnnotation;